<template>
    <div id="app">
        <div class="login-container">
            <!-- 左侧面板 -->
            <div class="left-panel">
                <div class="back" @click="back">
                    <i class="el-icon-back"></i>
                </div>
                <div class="left-content">
                    
                    <div class="login-illustration">
                        <i class="el-icon-user"></i>
                    </div>
                    <h1>欢迎回来</h1>
                    <p>登录您的账户以继续使用我们的服务</p>
                </div>
            </div>
            
            <!-- 右侧登录表单 -->
            <div class="right-panel">
                <div class="login-form">
                    <h1 class="form-title">智捷文案侠</h1>
                    <h2 class="form-title">用户登录</h2>
                    
                    <el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="0">
                        <el-form-item prop="username" class="form-item">
                            <el-input
                                v-model="loginForm.username"
                                placeholder="请输入用户名"
                                size="large"
                                prefix-icon="el-icon-user"
                                clearable>
                            </el-input>
                        </el-form-item>
                        
                        <el-form-item prop="password" class="form-item">
                            <el-input
                                v-model="loginForm.password"
                                type="password"
                                placeholder="请输入密码"
                                size="large"
                                prefix-icon="el-icon-lock"
                                show-password
                                clearable>
                            </el-input>
                        </el-form-item>
                        
                        <el-form-item prop="captcha" class="form-item">
                            <div class="verification-row">
                                <el-input
                                    v-model="loginForm.captcha"
                                    placeholder="请输入验证码"
                                    size="large"
                                    prefix-icon="el-icon-key"
                                    class="verification-input"
                                    maxlength="4"
                                    clearable>
                                </el-input>
                                <div class="verification-code" @click="refreshCaptcha">
                                    {{ captchaCode }}
                                </div>
                            </div>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button
                                type="primary"
                                class="login-button"
                                size="large"
                                :loading="loading"
                                @click="handleLogin">
                                {{ loading ? '登录中...' : '登录' }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                    
                    <!-- <div class="forgot-password">
                        <a href="javascript:void(0)" @click="handleForgotPassword">忘记密码？</a>
                    </div> -->
                </div>
                
                <!-- 版权信息栏 -->
                <div class="footer-bar">
                    <div class="footer-content">
                        <p class="copyright">© 2025 北京启尧致远科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025149969号-1</a></p>
                        <!-- <p class="links">
                            <a href="javascript:void(0)">使用条款</a>
                            <span class="divider">|</span>
                            <a href="javascript:void(0)">隐私政策</a>
                            <span class="divider">|</span>
                            <a href="javascript:void(0)">联系我们</a>
                        </p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    captcha: ''
                },
                captchaCode: '',
                loading: false,
                rules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                    captcha: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                        { len: 4, message: '验证码长度为 4 位', trigger: 'blur' },
                        { validator: this.validateCaptcha, trigger: 'blur' }
                    ]
                }
            }
        },
        mounted() {
            this.generateCaptcha();
        },
        methods: {
            // 生成验证码
            generateCaptcha() {
                const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
                let result = '';
                for (let i = 0; i < 4; i++) {
                    result += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                this.captchaCode = result;
            },
            
            // 刷新验证码
            refreshCaptcha() {
                this.generateCaptcha();
                this.loginForm.captcha = '';
            },
            
            // 验证码校验
            validateCaptcha(rule, value, callback) {
                if (value.toLowerCase() !== this.captchaCode.toLowerCase()) {
                    callback(new Error('验证码错误'));
                } else {
                    callback();
                }
            },
            
            // 处理登录
            async handleLogin() {
                this.$refs.loginForm.validate(async (valid) => {
                    if (!valid) {
                    this.$message.error('请检查输入信息')
                    return
                    }

                    this.loading = true
                    try {
                    // 调用后端接口
                    const res = await this.$api.post('/api/user/login', {
                        account: this.loginForm.username,
                        password: this.loginForm.password
                    })

                    console.log('登录结果:', res)

                    // 假设 FastAdmin 返回 { token: 'xxxx' }
                    localStorage.setItem('token', res.data.userinfo.token)
                    localStorage.setItem('userInfo',JSON.stringify(res.data.userinfo))
                    this.$store.commit('setUserInfo', res.data.userinfo); // 存储用户信息到 Vuex

                    this.$message.success('登录成功!')

                    // 跳转
                    this.$router.push('/')

                    } catch (err) {
                    console.error('登录失败:', err)
                    this.$message.error(err.message || '登录失败')
                    } finally {
                    this.loading = false
                    }
                })
            },

            
            // 处理忘记密码
            handleForgotPassword() {
                this.$message({
                    type: 'info',
                    message: '请联系销售人员重置密码'
                });
            },
            back(){
                this.$router.go(-1)
            }
        }
    }
    
</script>
<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    
    body {
        font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        height: 100vh;
        overflow: hidden;
    }
    
    .login-container {
        display: flex;
        height: 100vh;
        box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
    }
    
    .left-panel {
        flex: 1;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
    }
    
    .left-panel::before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
        animation: float 20s ease-in-out infinite;
    }
    
    @keyframes float {
        0%, 100% { transform: translateY(0px) rotate(0deg); }
        50% { transform: translateY(-20px) rotate(5deg); }
    }
    
    .left-content {
        text-align: center;
        color: white;
        z-index: 1;
        position: relative;
    }
    
    .left-content h1 {
        font-size: 3rem;
        margin-bottom: 20px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        animation: slideInLeft 1s ease-out;
    }
    
    .left-content p {
        font-size: 1.2rem;
        opacity: 0.9;
        animation: slideInLeft 1s ease-out 0.3s both;
    }
    
    .login-illustration {
        width: 300px;
        height: 300px;
        margin: 0 auto 30px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 255, 255, 0.2);
        animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }
    
    .login-illustration i {
        font-size: 120px;
        color: rgba(255, 255, 255, 0.8);
    }
    
    .right-panel {
        width: 500px;
        background: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        position: relative;
    }
    
    .login-form {
        width: 350px;
        padding: 40px;
        margin-top: auto;
        margin-bottom: auto;
        animation: slideInRight 1s ease-out;
    }
    
    .form-title {
        text-align: center;
        margin-bottom: 40px;
        color: #333;
        font-size: 28px;
        font-weight: bold;
    }
    
    .form-item {
        margin-bottom: 25px;
    }
    
    .verification-row {
        display: flex;
        gap: 10px;
    }
    
    .verification-input {
        flex: 1;
    }
    
    .verification-code {
        width: 110px;
        height: 40px;
        background: #f0f0f0;
        border: 1px solid #ddd;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Courier New', monospace;
        font-size: 18px;
        font-weight: bold;
        color: #666;
        cursor: pointer;
        user-select: none;
        transition: all 0.3s;
    }
    
    .verification-code:hover {
        background: #e0e0e0;
        border-color: #409eff;
    }
    
    .login-button {
        width: 100%;
        height: 45px;
        font-size: 16px;
        border-radius: 25px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        transition: all 0.3s;
    }
    
    .login-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    }
    
    .forgot-password {
        text-align: center;
        margin-top: 20px;
    }
    
    .forgot-password a {
        color: #409eff;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s;
    }
    
    .forgot-password a:hover {
        color: #66b1ff;
    }
    
    /* 版权信息栏样式 */
    .footer-bar {
        width: 100%;
        /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
        padding: 20px 0;
        /* border-top: 1px solid rgba(102, 126, 234, 0.2); */
    }
    
    .footer-content {
        text-align: center;
        /* color: white; */
    }
    
    .copyright {
        font-size: 14px;
        margin-bottom: 8px;
        opacity: 0.9;
    }
    
    .links {
        font-size: 12px;
        opacity: 0.8;
    }
    
    .links a {
        color: white;
        text-decoration: none;
        transition: opacity 0.3s;
    }
    
    .links a:hover {
        opacity: 1;
        text-decoration: underline;
    }
    
    .divider {
        margin: 0 10px;
        opacity: 0.6;
    }
    
    @keyframes slideInLeft {
        from {
            opacity: 0;
            transform: translateX(-50px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    
    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(50px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    
    /* 响应式设计 */
    @media (max-width: 768px) {
        .login-container {
            flex-direction: column;
        }
        
        .left-panel {
            height: 40vh;
        }
        
        .left-content h1 {
            font-size: 2rem;
        }
        
        .login-illustration {
            width: 200px;
            height: 200px;
        }
        
        .login-illustration i {
            font-size: 80px;
        }
        
        .right-panel {
            width: 100%;
            height: 60vh;
        }
        
        .footer-bar {
            padding: 15px 0;
        }
        
        .copyright {
            font-size: 12px;
        }
        
        .links {
            font-size: 11px;
        }
    }
    .back{
        position: fixed;
        left: 2%;
        top: 5%;
        background-color: #ffffff;
        border-radius: 50%;
        padding: 5px;
        z-index: 10;
    }
    .back .el-icon-back{
        font-size: 25px;
    }
</style>